import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import { HeroLayout, Index } from 'gatsby-theme-doctornpm';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = HeroLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    {
      /* edit the output of Index in `src/nav-base.yml` */
    }
    <Index depth='1' mdxType="Index" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      